import { useStaticQuery, graphql } from 'gatsby'

/**
 * A hook that retrieves the site metadata from a GraphQL query.
 * @function
 * @returns {object} - An object containing the site metadata, with properties: title, description, author and siteUrl.
 */
export const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  )

  return site.siteMetadata
}
